import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type SendPushWorkRecordBody = Parameters<typeof apiClient.v2.apiV2WorkrecordElSendPush>[0]

const sendPushWorkRecord = async (body: SendPushWorkRecordBody) => {
  const { data } = await apiClient.v2.apiV2WorkrecordElSendPush(body)
  return checkApiResponse(data)
}

export const useV2WorkRecordSendPushMutation = ({ options }: MutationComposableParams<unknown, SendPushWorkRecordBody> = {}) => {
  return useMutation(() => ({
    mutationFn: sendPushWorkRecord,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
